import React, { useState, useEffect } from "react";
import CheckboxOn from "../../../assets/images/CheckboxOn.svg";
import CheckboxOff from "../../../assets/images/CheckboxOff.svg";
import Dropdown from "react-dropdown";
import DownYellow from "../../../assets/images/downYellow.svg";
import { Button } from 'react-bootstrap';
import ButtonGroup from 'react-bootstrap/ButtonGroup';
import { useSelector, useDispatch } from "react-redux";
import ShoppingCart from ".";

function ShoppingCartIndividualTest(props) {
  let { val, i, recipientArray, ind, radiovalue, mobileview } = props;

  console.log(val, "fhjhjnkm")

  const cartState = useSelector((state) => state.cartsData);

  const [checked, setChecked] = useState(false);

  const [checkedState, setCheckedState] = useState();

  const [testQuantity, setTestQuantity] = useState(1);
  const [selectedRecipientId, setSelectedRecipientId] = useState([]);
  const [selectedRecipientNames, setSelectedRecipientNames] = useState([]);
  const [testPrice, setTestPrice] = useState();
  const [maintestPrice, setMainTestPrice] = useState();
  const [qtyValue, setQtyValue] = useState([]);
  const [homeServicePrice, setHomeServicePrice] = useState();
  const [dropdownPlaceHolder, setDropdownPlaceHolder] = useState('Select Recipient');

  const handleRadio = (e, id, val) => {
    setChecked(e.target.checked);
    props.handleRadio(id, val);
  };

  useEffect(() => {
    if (radiovalue && JSON.stringify(radiovalue).includes(val.uuid)) {
      setChecked(true);
    } else {
      setChecked(false);
    }
  }, [radiovalue]);

  // useEffect(() => {
  //   setTestPrice(val?.tests?.doctallsexclusivediscountedprice)
  //   setMainTestPrice(val?.tests?.labretailprice)
  //   let qty = [];
  //   cartState.data.homeservice.map((i) => qty.push({ value: 1 }));
  //   setQtyValue(qty)
  //   setHomeServicePrice(val?.tests?.doctallsexclusivediscountedprice)
  // }, [])


  // useEffect(() => {
  //   let price = Number(val.tests.doctallsexclusivediscountedprice) * testQuantity
  //   let MainPrice = Number(val?.tests?.labretailprice) * testQuantity
  //   setTestPrice(price)
  //   setMainTestPrice(MainPrice)
  //   console.log(price, "hfcvjxkvjkcnvcx")
  //   if (testQuantity == selectedRecipientNames.length) {
  //     setDropdownPlaceHolder('')
  //   } else {
  //     let _placeHolder = `Select Recipient`
  //     setDropdownPlaceHolder(_placeHolder)
  //   }

  // }, [selectedRecipientNames, testQuantity, selectedRecipientId])

  // const handleHomeSampleIncrese = () => {
  //   if (recipientArray?.length == testQuantity) {
  //     console.log("You have 0 recipient available to add, quantity can not be more than available recipient")
  //   } else {
  //     let quantity = Number(testQuantity + 1)
  //     setTestQuantity(quantity)
  //     let updatedItemValues = val
  //     updatedItemValues.patient_uuid = selectedRecipientId
  //     updatedItemValues['quantity'] = quantity
  //   }
  // }

  // const handleHomeSampleDecrese = () => {
  //   if (testQuantity == selectedRecipientNames?.length) {
  //     console.log("You have 0 recipient available to add, quantity can not be more than available recipient")
  //   } else {
  //     if (testQuantity === 1) {

  //     } else {
  //       if (testQuantity > 1) {
  //         let quantity = Number(testQuantity - 1)
  //         setTestQuantity(quantity)
  //         let updatedItemValues = val
  //         updatedItemValues.patient_uuid = selectedRecipientId
  //         updatedItemValues['quantity'] = quantity
  //       }
  //     }
  //   }
  // }


  // const handleIncreseQuantity = () => {
  //   if (recipientArray?.length == testQuantity) {
  //     console.log("You have 0 recipient available to add, quantity can not be more than available recipient")
  //   } else {
  //     let quantity = Number(testQuantity + 1)
  //     setTestQuantity(quantity)
  //     let updatedItemValues = val
  //     updatedItemValues['quantity'] = quantity

  //   }
  // }

  // const handleDecreseQuantity = () => {
  //   if (testQuantity === 1) {
  //     console.log("You have 0 recipient available to add, quantity can not be more than available recipient")
  //   } else {
  //     if (testQuantity > 1) {
  //       let quantity = Number(testQuantity - 1)
  //       setTestQuantity(quantity)
  //       let updatedItemValues = val
  //       updatedItemValues['quantity'] = quantity

  //     }
  //   }
  // }


  return (
    <>
      <div className="inner-content-row-wrap" key={ind}>
        <div className="col-md-4">
          <div className="left-cont-out">
            <div className="top-font">
              {val.tests.standardisedtestname}

              {JSON.stringify(i.patient_uuid)}
            </div>


            {val.isRecommendedTest && (
              <div className="middle-font" style={{ color: 'blue' }}>
                Recommended Test
              </div>
            )}

            {val.name !== "Home Service Charge" && (
              <div className="middle-font">
                Results Expected in :{val.tests.partnerlabtat}
              </div>
            )}
          </div>
        </div>

        {!mobileview ? (
          <>

            {/* {!val.isRecommendedTest && <div className="center-cont-out">

              {val.name !== "Home Service Charge" ? <ButtonGroup>
                <Button variant='light' onClick={handleDecreseQuantity} className='quantity_btn' disabled={testQuantity === 1 ? true : false}>-</Button>
                <span style={{ backgroundColor: 'white', borderColor: 'white', color: 'black', marginRight: "15px", marginLeft: "15px", display: "flex", alignItems: "center" }}>{testQuantity}</span>
                <Button variant='light' onClick={handleIncreseQuantity} className='quantity_btn'>+</Button>
              </ButtonGroup> : <ButtonGroup>
                <Button variant='light' onClick={handleHomeSampleDecrese} className='quantity_btn' disabled={testQuantity === 1 ? true : false} >-</Button>
                <span style={{ backgroundColor: 'white', borderColor: 'white', color: 'black', marginRight: "15px", marginLeft: "15px", display: "flex", alignItems: "center" }}>{testQuantity}</span>
                <Button variant='light' onClick={handleHomeSampleIncrese} className='quantity_btn'>+</Button>
              </ButtonGroup>}
            </div>}

            {val.isRecommendedTest && <div>1</div>} */}

            <div className="col-md-2">
              <div className="center-cont-out">
                <div className="top-font">{val.quantity && val.quantity}</div>
              </div>
            </div>

            <div className="col-md-2">
              <div className="center-cont-out">
                <div className="top-font">
                  ₦{Number(val.cost).toFixed()}
                </div>
                <div className="bottom-font">₦{Number(val.tests.labretailprice).toFixed()}</div>
              </div>
            </div>
            {/* <div className='col-md-2 inner-content-align_price' >
              <div className="center-cont-out ">
                <div>
                  <div className="top-font">
                    ₦{Number(testPrice).toFixed()}
                  </div>
                  <div className="bottom-font">
                    ₦{Number(maintestPrice).toFixed()}
                  </div>
                </div>
              </div>
            </div> */}
          </>
        ) : (
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              width: "100%",
            }}
          >
            <div className="col-md-2">
              <div className="center-cont-out">
                <span  style={{color:"#717782",fontSize:"14px",lineHeight:"18px"}}>Quantity</span>
                <div className="top-font">{val.quantity && val.quantity}</div>
              </div>
            </div>
            <div className="col-md-2">
              <div className="center-cont-out">
                <div className="top-font">
                  ₦{val.tests.doctallsexclusivediscountedprice}
                </div>
                <div className="bottom-font">₦{val.tests.labretailprice}</div>
              </div>
            </div>
          </div>
        )}

        <div className="col-md-4">
          <div className="right-cont-out">
            {val.patient_name
              .toString()
              .replace(",", ",                      ")}
          </div>
        </div>
      </div>
    </>
  );
}

export default ShoppingCartIndividualTest;
